import { PaymentLifecycleIconsView } from './PaymentLifecycleIconsView';
const meta = {
    title: 'Features/Invoices/PaymentLifecycleIcons',
    component: PaymentLifecycleIconsView,
    parameters: { layout: 'centered' }
};
export default meta;
const at = '2026-05-18T10:05:00Z';
// Single-event stories — the icon shows the latest status, no clickable
// behavior since there's nothing more to reveal.
export const Approved = { args: { event: { status: 'approved', occurredAt: at } } };
export const Captured = { args: { event: { status: 'captured', occurredAt: at } } };
export const Settled = { args: { event: { status: 'settled', occurredAt: at } } };
export const Failed = {
    args: { event: { status: 'failed', occurredAt: at, details: 'Insufficient Funds' } }
};
export const Returned = {
    args: { event: { status: 'returned', occurredAt: at, details: 'R01 — Insufficient Funds' } }
};
export const ManualCorrection = {
    args: { event: { status: 'manual_correction', occurredAt: at, details: 'Returned payment — IP-14340' } }
};
export const FullRefund = { args: { event: { status: 'refunded', occurredAt: at } } };
export const PartialRefund = {
    args: { event: { status: 'refunded', occurredAt: at, partial: true, details: '$200 of $1,000' } }
};
// History stories — the icon becomes clickable when `history` has more than
// one entry, and opens a modal showing every recorded lifecycle event.
export const HistoricallyCaptured = {
    args: {
        event: { status: 'captured', occurredAt: '2026-05-18T10:00:05Z' },
        history: [
            { status: 'approved', occurredAt: '2026-05-18T10:00:00Z' },
            { status: 'captured', occurredAt: '2026-05-18T10:00:05Z' }
        ]
    }
};
export const FullLifecycleHistory = {
    args: {
        event: { status: 'settled', occurredAt: '2026-05-19T08:00:00Z' },
        history: [
            { status: 'approved', occurredAt: '2026-05-18T10:00:00Z' },
            { status: 'captured', occurredAt: '2026-05-18T10:00:05Z' },
            { status: 'settled', occurredAt: '2026-05-19T08:00:00Z' }
        ]
    }
};
export const HistoryWithRefund = {
    args: {
        event: { status: 'refunded', occurredAt: '2026-05-18T12:19:14Z', partial: true, details: '$200 of $1,000' },
        history: [
            { status: 'approved', occurredAt: '2026-05-18T10:00:00Z' },
            { status: 'captured', occurredAt: '2026-05-18T10:00:05Z' },
            { status: 'refunded', occurredAt: '2026-05-18T12:19:14Z', partial: true, details: '$200 of $1,000' }
        ]
    }
};
export const HistoryWithManualCorrection = {
    args: {
        event: { status: 'manual_correction', occurredAt: '2026-06-15T17:50:00Z', details: 'Returned payment — IP-14340' },
        history: [
            { status: 'approved', occurredAt: '2026-05-18T10:00:00Z' },
            { status: 'captured', occurredAt: '2026-05-18T10:00:05Z' },
            { status: 'settled', occurredAt: '2026-05-19T08:00:00Z' },
            { status: 'manual_correction', occurredAt: '2026-06-15T17:50:00Z', details: 'Returned payment — IP-14340' }
        ]
    }
};
export const NoEvent = {
    args: { event: null },
    parameters: { docs: { description: { story: 'Renders nothing when there is no known lifecycle event.' } } }
};
